import React from 'react';
import { Editor, Node } from 'slate';
import { ReactEditor } from 'slate-react';

import * as serializer from 'basic-editor-value-serializer';

import Helpers from '../helpers';

import nodeControls from './control-types';
import ExpandableNodeActionMenuItem from './menu-item';
import LayoutSettingsReactWrapper from './layout-settings/react';
import { findPreviewBreakpoint } from './layout-settings/preview-breakpoint';

import { ReactComponent as LayoutIcon } from 'assets/images/multiple-columns-icon.svg';
import { ReactComponent as SizeIcon } from 'assets/images/node-menu-width-height-icon.svg';

const DEFAULT_FIXED_SIZE = 240;

function findPreview(editor) {

  try {
    return findPreviewBreakpoint(ReactEditor.toDOMNode(editor, editor));
  } catch (exception) {
    return 'desktop';
  }

}

// Switching to Fixed starts from the size the block has on screen, so nothing jumps.
function measureBlock(editor, path, isRow) {

  try {
    const rectangle = ReactEditor.toDOMNode(editor, Node.get(editor, path)).getBoundingClientRect();
    if (isRow === true) {
      return Math.round(rectangle.width);
    }
    return Math.round(rectangle.height);
  } catch (exception) {
    return DEFAULT_FIXED_SIZE;
  }

}

function renderLayoutSettingsContent(menu) {

  const editor = menu.editor;
  const path = menu.elementPath;

  function write(breakpoint, changes) {
    Helpers.layout.saveLayoutSettings(editor, path, Helpers.layout.writeLayoutSettings(Node.get(editor, path), breakpoint, changes));
    menu.positionToolbar();
  }

  function reset(breakpoint, keys) {
    Helpers.layout.saveLayoutSettings(editor, path, Helpers.layout.resetLayoutSettings(Node.get(editor, path), breakpoint, keys));
    menu.positionToolbar();
  }

  function read(breakpoint) {
    return Helpers.layout.readLayoutBreakpoint(Node.get(editor, path), breakpoint);
  }

  return <LayoutSettingsReactWrapper panel="createLayoutSettings" breakpoint={findPreview(editor)} value={editor.children} read={read} write={write} reset={reset} measure={measureBlock.bind(null, editor, path)} />;

}

function renderItemSettingsContent(menu) {

  const editor = menu.editor;
  const path = menu.elementPath;

  function write(breakpoint, changes) {
    Helpers.layout.saveItemSettings(editor, path, Helpers.layout.writeItemSettings(Node.get(editor, path), breakpoint, changes));
    menu.positionToolbar();
  }

  function reset(breakpoint, keys) {
    Helpers.layout.saveItemSettings(editor, path, Helpers.layout.resetItemSettings(Node.get(editor, path), breakpoint, keys));
    menu.positionToolbar();
  }

  function read(breakpoint) {
    return Helpers.layout.readItemBreakpoint(Node.parent(editor, path), Node.get(editor, path), breakpoint);
  }

  return <LayoutSettingsReactWrapper panel="createItemSettings" breakpoint={findPreview(editor)} value={editor.children} read={read} write={write} reset={reset} measure={measureBlock.bind(null, editor, path)} />;

}

function isLayoutChild(editor, path) {
  return path.length > 1 && Editor.parent(editor, path)[0].type === serializer.types.LAYOUT;
}

// menu: { editor, elementPath, customNodeControls, activeMenuItemName, positionToolbar, toggleActiveMenuItem }
export function tryRenderLayoutSettingsMenuItem(menu) {

  if (menu.customNodeControls.indexOf(nodeControls.LAYOUT_SETTINGS) === -1) {
    return null;
  }

  return <ExpandableNodeActionMenuItem Icon={LayoutIcon} name="Layout" activeMenuItemName={menu.activeMenuItemName}
    contentRenderer={renderLayoutSettingsContent.bind(null, menu)} positionToolbar={menu.positionToolbar} toggleActiveMenuItem={menu.toggleActiveMenuItem} />;

}

// Every child of a layout gets this item, so no element type has to opt in.
export function tryRenderLayoutItemSettingsMenuItem(menu) {

  if (isLayoutChild(menu.editor, menu.elementPath) === false) {
    return null;
  }

  return <ExpandableNodeActionMenuItem Icon={SizeIcon} name="Size in layout" activeMenuItemName={menu.activeMenuItemName}
    contentRenderer={renderItemSettingsContent.bind(null, menu)} positionToolbar={menu.positionToolbar} toggleActiveMenuItem={menu.toggleActiveMenuItem} />;

}
